module.exports = __webpack_public_path__ + "img/ksaf.f8a1692a.webp";